<template>
  <div class="wt2-duration">
    <input
      type="text"
      ref="input"
      :value="displayValue"
      @keydown="onKeyboardEvent"
      @change="onChange"
    />
    <div class="-arrow-box">
      <i
        class="-arrow -top"
        :class="{
          '-disabled': max === nValue,
        }"
        @click="process(nValue + step)"
      />
      <i
        class="-arrow -bottom"
        :class="{
          '-disabled': min === nValue,
        }"
        @click="process(nValue - step)"
      />
    </div>
    <span class="-error" />
  </div>
</template>

<script>
import app from 'app';

export default {
  inheritAttrs: false,

  props: {
    min: {
      type: Number,
      default: 300, // 3 seconds
    },

    max: {
      type: Number,
      default: 720000, // 12 min
    },

    step: {
      type: Number,
      default: 500, // 0.5 seconds
    },

    formats: {
      type: Array,
      default: () => [
        { format: 's.SS', lessThen: 60000 },
        { format: 'mm:ss.SS', lessThen: Infinity },
      ],
    },

    dataList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      nValue: null,
      isValid: false,
    };
  },

  computed: {
    fromAttrs() {
      return this.getMillisecondsFromOptions(this.$attrs);
    },

    displayValue() {
      return app.moment.utc(this.nValue).format(this.getCurFormat().format);
    },
  },

  watch: {
    fromAttrs: {
      handler(ms) {
        this.nValue = ms;
      },
      immediate: true,
    },
  },

  methods: {
    getCurFormat() {
      return _.find(this.formats, (f) => {
        return this.nValue < f.lessThen;
      });
    },

    getMillisecondsFromOptions(options) {
      const {
        seconds = 0,
        minutes = 0,
        hours = 0,
        days = 0,
        weeks = 0,
        months = 0,
        years = 0,
      } = options;

      return app.moment
        .duration({
          seconds: seconds,
          minutes: minutes,
          hours: hours,
          days: days,
          weeks: weeks,
          months: months,
          years: years,
        })
        .asMilliseconds();
    },

    getSeconds(value) {
      return app.moment.duration(value).asSeconds();
    },

    getNewValueFromKey(key) {
      let newValue;

      switch (true) {
        case _.isEqual(key, 'arrow-up'):
          newValue = this.nValue + this.step;
          break;
        case _.isEqual(key, 'arrow-down'):
          newValue = this.nValue - this.step;
          break;
      }

      return newValue;
    },

    onKeyboardEvent(e) {
      const key = _.kebabCase(e.key);
      const newValue = this.getNewValueFromKey(key);

      if (!newValue) {
        return;
      }

      this.process(newValue);
    },

    vMin(v) {
      return v < this.min ? this.min : v;
    },

    vMax(v) {
      return v > this.max ? this.max : v;
    },

    vIsNan(v) {
      return _.isNaN(v) ? 0 : v;
    },

    vToNumber(v) {
      const isNumber = _.isNumber(v);

      if (isNumber) {
        return v;
      }

      const parts = v.match(/[0-9]+/g);

      if (!parts || !parts.length) {
        return 0;
      }

      const partsNum = _.map(parts, _.parseFloat);

      // ie: 40
      if (partsNum.length === 1) {
        return partsNum[0] * app.TIME.SECOND;
        // ie: 40:20, 40:2åå
      } else if (partsNum.length === 2) {
        return (
          partsNum[0] * app.TIME.SECOND +
          _.parseInt(_.padEnd(partsNum[1], 2, 0) * 10)
        );
        // ie: 40:20:30
      } else if (partsNum.length === 3) {
        return (
          partsNum[0] * app.TIME.MINUTE +
          partsNum[1] * app.TIME.SECOND +
          _.parseInt(_.padEnd(partsNum[2], 2, 0) * 10)
        );
      } else {
        return 0;
      }
    },

    process(newValue) {
      const validator = _.flow(
        this.vIsNan,
        this.vToNumber,
        this.vMin,
        this.vMax
      );

      this.nValue = validator(newValue);
      this.$refs.input.value = this.displayValue;
      this.$emit('change', this.getSeconds(this.nValue));
    },

    onChange(e) {
      this.process(e.target.value);
    },
  },
};
</script>
